import React from 'react'
import { Container, Row, Col } from "react-bootstrap"; // For grid layout
import styles from './Footer.module.css'; // Import corresponding CSS module
const Footer = () => {
  return (
    <>
     <footer className={styles.footer}>
      <Container>
        <Row>
          {/* Left Section - About Us */}
          <Col md={4} className={styles.aboutSection}>
            <h5>About Us</h5>
            <p>
              We are dedicated to connecting talented professionals with their
              dream jobs. Our mission is to simplify the job search process for
              both companies and candidates.
            </p>
          </Col>

          {/* Middle Section - Links */}
          <Col md={4} className={styles.linksSection}>
            <h5>Quick Links</h5>
            <ul className={styles.linksList}>
              <li><a href="#home">Home</a></li>
              <li><a href="#jobs">Job Listings</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#contact">Contact</a></li>
              <li><a href="#terms">Terms & Conditions</a></li>
              <li><a href="#privacy">Privacy Policy</a></li>
            </ul>
          </Col>

          {/* Right Section - Contact & Social */}
          <Col md={4} className={styles.contactSection}>
            <h5>Contact</h5>
            <p>Email: <a href="mailto:info@jobsite.com">info@jobsite.com</a></p>
            <p>Phone: <a href="tel:+123456789">+1 234 567 89</a></p>
            
            <div className={styles.socialLinks}>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>FB</a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>TW</a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>LI</a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>IG</a>
            </div>
          </Col>
        </Row>

        {/* Footer Bottom */}
        <Row className={styles.footerBottom}>
          <Col className="text-center">
            <p>&copy; {new Date().getFullYear()} JobSite. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
    </>
  )
}

export default Footer